import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AllScores, Score } from 'src/models/score.model';

@Injectable({
   providedIn: 'root',
})
export class ScoreService {

   constructor(private http: HttpClient) { }

   scores(): Observable<Score[]> {
      return this.http.get<Score[]>(`/score`);
   }
   allScores(): Observable<AllScores[]> {
      return this.http.get<AllScores[]>(`/score/all`);
   }
   superallScores(): Observable<AllScores[]> {
      return this.http.get<AllScores[]>(`/score/superall`);
   }

}

